export default "__VITE_ASSET__DCYagTvd__"